import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "width", "height"];
import React from 'react';

var getFill = function getFill(type) {
  switch (type) {
    case 'A':
      return '#00A651';

    case 'B':
      return '#50B848';

    case 'C':
      return '#BFD730';

    case 'D':
      return '#FFF200';

    case 'E':
      return '#FDB913';

    case 'F':
      return '#F37021';

    case 'G':
      return '#ED1C24';

    default:
      return '#00A651';
  }
};

var getLetterPath = function getLetterPath(type) {
  switch (type) {
    case 'A':
      return 'M41.9117 43.9645H42.0522L42.0998 43.8324L44.7587 36.4573H56.5295L59.2275 43.8332L59.2755 43.9645H59.4154H63.3073H63.5979L63.4941 43.6931L52.49 14.9285L52.4409 14.8H52.3032H48.9843H48.8465L48.7974 14.9287L37.8132 43.6932L37.7095 43.9645H38H41.9117ZM46.0493 32.9359L50.6441 20.2677L55.2575 32.9359H46.0493Z';

    case 'B':
      return 'M42.8 43.7645V43.9645H43H52.9767C56.0629 43.9645 58.4805 43.2194 60.2013 41.7019C61.924 40.1827 62.7781 38.0959 62.7781 35.4671C62.7781 33.7435 62.3128 32.2517 61.3756 31.0017C60.5505 29.8737 59.4542 29.0718 58.0936 28.5958C59.2185 28.0362 60.1297 27.2917 60.8222 26.3604L60.823 26.3594C61.6131 25.2832 62.0076 24.0494 62.0076 22.6653C62.0076 20.0924 61.2014 18.1191 59.5637 16.7814C57.9458 15.4492 55.5477 14.8 52.4038 14.8H43H42.8V15V43.7645ZM56.3656 25.8698L56.3646 25.8706C55.4221 26.6623 54.1485 27.0684 52.5223 27.0684H46.9931V18.3214H52.4038C54.2676 18.3214 55.6172 18.6809 56.4882 19.3653L56.4896 19.3664C57.3463 20.0272 57.7947 21.1033 57.7947 22.6455C57.7947 24.0148 57.3161 25.0819 56.3656 25.8698ZM53.0557 40.4629H46.9931V30.5108H53.115C54.9715 30.5108 56.3266 30.938 57.2173 31.757C58.1047 32.573 58.5652 33.81 58.5652 35.5066C58.5652 37.0668 58.0686 38.2731 57.0907 39.1508C56.1231 40.0179 54.7863 40.4629 53.0557 40.4629Z';

    case 'C':
      return 'M64.2138 33.8415L64.2399 33.6183H64.0151H60.0527H59.8814L59.855 33.7876C59.4749 36.2312 58.7065 37.9062 57.5827 38.8602C56.4684 39.804 54.8449 40.2909 52.6821 40.2909C50.3077 40.2909 48.4742 39.3619 47.1583 37.5011C45.8347 35.6293 45.1625 33.0943 45.1625 29.8764V26.9815C45.1625 23.5705 45.8695 20.9716 47.2563 19.1579C48.6525 17.3496 50.5697 16.4439 53.0311 16.4439C55.0499 16.4439 56.5894 16.9682 57.6778 17.991L57.6787 17.9918C58.7811 19.0155 59.5157 20.6883 59.8547 23.0475L59.8793 23.2191H60.0527H64.0151H64.2362L64.2141 22.9991C63.8955 19.8268 62.7636 17.3276 60.8043 15.5221C58.8436 13.7016 56.2454 12.8 53.0311 12.8C50.6031 12.8 48.4578 13.3762 46.6022 14.5341C44.7461 15.6786 43.3116 17.3244 42.2975 19.4637L42.297 19.4646C41.297 21.6037 40.8 24.0767 40.8 26.8789V29.7532C40.8 34.0296 41.8696 37.4671 44.029 40.0444L44.0294 40.0449C46.2054 42.6254 49.0963 43.9142 52.6821 43.9142C55.9754 43.9142 58.6337 43.0487 60.636 41.2984L60.636 41.2984C62.652 39.5344 63.8398 37.0414 64.2138 33.8415Z';

    case 'D':
      return 'M42.8 43.7645V43.9645H43L50.9616 43.9645L50.9637 43.9645C53.5733 43.9379 55.8662 43.3717 57.836 42.2595C59.8203 41.1467 61.3425 39.55 62.4004 37.4747C63.471 35.4003 64.0029 32.9906 64.0029 30.2515L64.0029 28.4142L64.0029 28.4132C63.9896 25.7394 63.4507 23.3633 62.3807 21.2899C61.3232 19.2153 59.8149 17.6124 57.8574 16.4861C55.9004 15.3602 53.6525 14.8 51.1197 14.8H43H42.8V15V43.7645ZM57.4508 37.8029L57.4503 37.8035C55.8758 39.5699 53.6631 40.4629 50.7838 40.4629H46.9931V18.3214H51.2175C53.9892 18.3475 56.1018 19.2518 57.5848 21.0159L57.5858 21.0171C59.0859 22.7737 59.8493 25.2567 59.8493 28.4933V30.1725C59.8493 33.5002 59.0404 36.0339 57.4508 37.8029Z';

    case 'E':
      return 'M60.2591 30.6688H60.4591V30.4688V27.3672V27.1672H60.2591H47.9931V18.3214H62.0766H62.2766V18.1214V15V14.8H62.0766H44H43.8V15V43.7645V43.9645H44H62.2742H62.4742V43.7645V40.6629V40.4629H62.2742H47.9931V30.6688H60.2591Z';

    case 'F':
      return 'M59.864 33.2615H60.064V33.0615V29.9598V29.7598H59.864H47.9931V20.3214H61.8198H62.0198V20.1214V17V16.8H61.8198H44H43.8V17V45.7645V45.9645H44H47.7931H47.9931V45.7645V33.2615H59.864Z';

    case 'G':
      return 'M64.1997 40.4967L64.2357 40.4451V40.3822V29.4187V29.2187H64.0357H53.1953H52.9953V29.4187V32.6215V32.8215H53.1953H59.9143V39.2557C59.2238 39.9777 58.3564 40.4952 57.3063 40.8064C56.2204 41.1281 54.9468 41.2909 53.4828 41.2909C50.9271 41.2909 48.9132 40.3314 47.4201 38.4121C45.9221 36.4726 45.1625 33.8513 45.1625 30.5274V28.0846C45.1761 24.5883 45.8569 21.9543 47.1767 20.1546C48.5019 18.3522 50.4426 17.4439 53.0311 17.4439C54.9826 17.4439 56.5134 17.9296 57.6451 18.8804C58.7771 19.8314 59.5334 21.2675 59.8971 23.214L59.9276 23.3773H60.0937H64.0357H64.2667L64.2336 23.1486C63.8037 20.181 62.6212 17.8741 60.674 16.2489C58.727 14.6102 56.1659 13.8 53.0106 13.8C49.1579 13.8 46.1413 15.0567 43.9889 17.5865L43.9885 17.587C41.8538 20.1123 40.8 23.6547 40.8 28.1868L40.8 30.7943L40.8 30.7962C40.8276 33.599 41.3593 36.0724 42.4011 38.2114L42.4015 38.2123C43.4575 40.3519 44.9472 42.0103 46.8705 43.181L46.8714 43.1815C48.7946 44.3382 50.9935 44.9142 53.4623 44.9142C55.8905 44.9142 58.0241 44.5555 59.8591 43.8327L59.8598 43.8324C61.7125 43.0941 63.162 41.983 64.1997 40.4967Z';

    default:
      return 'M41.9117 43.9645H42.0522L42.0998 43.8324L44.7587 36.4573H56.5295L59.2275 43.8332L59.2755 43.9645H59.4154H63.3073H63.5979L63.4941 43.6931L52.49 14.9285L52.4409 14.8H52.3032H48.9843H48.8465L48.7974 14.9287L37.8132 43.6932L37.7095 43.9645H38H41.9117ZM46.0493 32.9359L50.6441 20.2677L55.2575 32.9359H46.0493Z';
  }
};

var EnergyLabel = function EnergyLabel(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'A' : _ref$type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '71' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '40' : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 59",
    width: width,
    height: height
  }, props, {
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9901 1.62012H22.5801V57.5501H78.9901L104.7 29.5801L78.9901 1.62012Z",
    fill: getFill(type)
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4298 1.21011H0.999847C0.891108 1.21011 0.786823 1.25331 0.709933 1.3302C0.633043 1.40709 0.589847 1.51137 0.589847 1.62011V57.5501C0.584248 57.6072 0.590699 57.6649 0.608781 57.7193C0.626864 57.7738 0.656175 57.8238 0.69482 57.8662C0.733465 57.9087 0.780582 57.9425 0.833125 57.9655C0.885669 57.9886 0.942467 58.0004 0.999847 58.0001H78.4298C78.4861 58.0002 78.5418 57.9887 78.5934 57.9663C78.645 57.9439 78.6914 57.9112 78.7299 57.8701L104.44 29.8701C104.511 29.7942 104.55 29.6941 104.55 29.5901C104.55 29.4861 104.511 29.3861 104.44 29.3101L78.7299 1.31011C78.689 1.27441 78.6414 1.24719 78.5899 1.23002C78.5384 1.21286 78.484 1.20609 78.4298 1.21011V1.21011Z",
    stroke: "#231F20",
    strokeWidth: "0.82",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: getLetterPath(type),
    fill: "white",
    stroke: "black",
    strokeWidth: "0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2252 15.6427H8.6248L7.14242 19.7544H5L11.0161 4H12.8339L18.8608 19.7544H16.7292L15.2252 15.6427ZM9.25238 13.933H14.6084L11.925 6.56441L9.25238 13.933Z",
    fill: "#231C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2598 35.7V23.77",
    stroke: "#1C1A00",
    strokeWidth: "2.22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 27.16L12.17 24L9 27.16",
    stroke: "#1C1A00",
    strokeWidth: "2.22",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.083 52.6931C16.5957 53.3912 15.9141 53.9147 15.0383 54.2637C14.169 54.6062 13.1549 54.7774 11.9959 54.7774C10.8237 54.7774 9.78325 54.5041 8.87448 53.9575C7.96571 53.4044 7.26108 52.6207 6.7606 51.6066C6.2667 50.5924 6.01317 49.417 6 48.0801V46.8256C6 44.6591 6.50377 42.9798 7.51132 41.7879C8.52546 40.596 9.94788 40 11.7786 40C13.28 40 14.4884 40.3852 15.4038 41.1557C16.3191 41.9196 16.8789 43.0062 17.083 44.4154H15.1865C14.8309 42.5123 13.6982 41.5607 11.7885 41.5607C10.5175 41.5607 9.55276 42.0085 8.89423 42.9041C8.24229 43.7931 7.91303 45.0838 7.90644 46.7763V47.9517C7.90644 49.5651 8.27522 50.8493 9.01277 51.8041C9.75032 52.7524 10.748 53.2265 12.0058 53.2265C12.717 53.2265 13.3393 53.1475 13.8727 52.9895C14.4061 52.8314 14.8473 52.5647 15.1964 52.1894V48.9593H11.8675V47.4183H17.083V52.6931Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("title", null, "EnergyRating".concat(type)));
};

EnergyLabel.displayName = 'EnergyLabel';
export default EnergyLabel;